<template>
  <component :is="tag"
             v-bind="$attrs"
             tag="li">
    <router-link class="" v-bind="$attrs">
      <slot>
        {{link.name}}
      </slot>
    </router-link>
  </component>
</template>
<script>
  export default {
    inheritAttrs: false,
    props: {
      link: {
        type: [String, Object],
        default: () => {
          return {
            name: '',
            path: '',
            icon: ''
          }
        }
      },
      tag: {
        type: String,
        default: 'router-link'
      }
    }
  }
</script>
<style>
</style>
